import { Auth0Provider, Auth0Context } from '@auth0/auth0-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const DevAuthProvider = ({ children }) => {
	const devUser = {
		sub: import.meta.env.VITE_DEV_USER_ID || 'dev|local-backoffice-user',
		email:
			import.meta.env.VITE_DEV_USER_EMAIL || 'dev-backoffice@localhost',
		name: import.meta.env.VITE_DEV_USER_NAME || 'Local Dev Admin',
	}

	const value = {
		isAuthenticated: true,
		isLoading: false,
		user: devUser,
		getAccessTokenSilently: async () => devUser.sub,
		loginWithRedirect: () => {},
		logout: () => {},
		getAccessTokenWithPopup: async () => '',
		getIdTokenClaims: async () => ({}),
		handleRedirectCallback: async () => ({}),
	}

	return (
		<Auth0Context.Provider value={value}>
			{children}
		</Auth0Context.Provider>
	)
}

export const Auth0ProviderWithNavigate = ({ children }) => {
	const navigate = useNavigate()

	if (import.meta.env.VITE_DEV_AUTH === 'true') {
		return <DevAuthProvider>{children}</DevAuthProvider>
	}

	const domain = import.meta.env.VITE_AUTH_DOMAIN
	const clientId = import.meta.env.VITE_AUTH_CLIENT_ID
	const redirectUri = `${window.location.origin}`
	const audience = import.meta.env.VITE_AUTH_AUDIENCE

	const onRedirectCallback = (appState) => {
		navigate(appState?.returnTo || window.location.pathname)
	}

	if (!(domain && clientId && redirectUri && audience)) {
		return null
	}

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			authorizationParams={{
				audience,
				redirect_uri: redirectUri,
				action: 'BackOffice',
			}}
			onRedirectCallback={onRedirectCallback}
		>
			{children}
		</Auth0Provider>
	)
}
